import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelecttemplateComponent } from './selecttemplate.component';
import { ModalModule } from '../modal/modal.module';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [SelecttemplateComponent],
  exports:[SelecttemplateComponent],
  imports: [
    CommonModule,
    FormsModule,
    ModalModule
  ]
})
export class SelecttemplateModule { }
